module.exports = __webpack_public_path__ + "files/38861cba61c66739c1452c3a71e39852.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-regular.ttf
 ** module id = 873
 ** module chunks = 0
 **/